import login from "../../images/login.svg";
import "./LoginImage.scss";

const LoginImage = () => {
  return (
    <div className="loginImage">
      <img
        src={login}
        height="337.57"
        alt="animated person holding a blue bag"
      />
    </div>
  );
};

export default LoginImage;
